<template>
  <div v-if="isVisible" class="token-refresh-indicator">
    <div class="indicator-content">
      <div class="spinner"></div>
      <span class="message">Обновление сессии...</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TokenRefreshIndicator',
  computed: {
    ...mapGetters(['isTokenRefreshing']),
    isVisible() {
      return this.isTokenRefreshing;
    }
  }
};
</script>

<style scoped>
.token-refresh-indicator {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  background: rgba(0, 123, 255, 0.9);
  color: white;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.indicator-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.message {
  font-size: 14px;
  font-weight: 500;
}
</style>